document.querySelectorAll(".js-load-more").forEach(button => {
  button.addEventListener("click", () => {
    const dataClick = button.getAttribute("attr");
    const loadMoreWrap = button.closest(".load-more_wrap");
    const totalPages = parseInt(loadMoreWrap.querySelector('[data-total-pages]').getAttribute("value"));
    const currentPageElement = loadMoreWrap.querySelector('[data-current-page]');
    let currentPage = parseInt(currentPageElement.getAttribute("value"));
    const loader = button.querySelector('[loader]');
    const loadMoreText = button.querySelector('[load-more-text]');
    button.setAttribute('disabled', true);
    if (loader) loader.classList.remove('hide');
    currentPage += 1;
    const nextUrl = loadMoreWrap.querySelector('[data-next-url]').value.replace(/page=[0-9]+/, `page=${currentPage}`);
    currentPageElement.setAttribute("value", currentPage);
    fetch(nextUrl, { method: 'GET' })
      .then(response => response.text())
      .then(responseHTML => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseHTML;
        const newContent = tempDiv.querySelector(`.${dataClick}`).innerHTML;
        document.querySelector(`.${dataClick}`).insertAdjacentHTML('beforeend', newContent);
      })
      .finally(() => {
        if (currentPage <= totalPages) {
          button.removeAttribute('disabled');
          if (loadMoreText) loadMoreText.classList.remove('hide');
          if (loader) loader.classList.add('hide');
        }
        if (currentPage === totalPages) {
          document.querySelector("button.js-load-more").style.display = 'none';
        }
        hideDuplicatePromos();
      });
  });
});
function hideDuplicatePromos() {
  const seenPromos = {
    promo_coloum1: false,
    promo_coloum2: false
  };
  document.querySelectorAll('.grid__promotion').forEach(function (element) {
    const promoClass = element.className.split(' ').find((cls) => seenPromos.hasOwnProperty(cls));
    if (promoClass) {
      if (seenPromos[promoClass]) {
        element.classList.add('hide');
      } else {
        seenPromos[promoClass] = true;
      }
    }
  });
}